import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/customBootstrap.scss";
import "./styles/react-grid-layout.css";
import "./styles/react-resizable.css";

import "./styles/customError.css";
import { BrowserRouter } from "react-router-dom";
import Loading from "./components/Loading";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import store, { persistor } from "store/store";
import VendorAuthWrapper from "auth/VendorAuth/VendorAuthWrapper";
import { SystemAuthProvider } from "auth/SystemAuth/context/context";
import { PersistGate } from "redux-persist/integration/react";
import ErrorBoundary from "components/ErrorBoundary";
import "./styles/default-ocean-blue-a11y.css";
import "./styles/app.css";
import '@fortawesome/fontawesome-free/css/all.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./styles/rfi.css";
import './styles/site.scss'; // this should be last to override any libraries
import { defineCustomElements } from "@duetds/date-picker/dist/loader";

defineCustomElements(window);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

// Get config data from file in production
// store.dispatch(loadConfig());
// const config = store.getState().config;

// const oidcConfig = {
//   authority: config.oidcConfig.authority,
//   client_id: config.oidcConfig.client_id,
//   redirect_uri: window.location.origin + "/login/callback",
//   post_logout_redirect_uri: window.location.origin,
//   response_type: "code",
//   scope: "openid profile api email roles",
//   client_secret: config.oidcConfig.client_secret, // Was set to "pkce", maybe don't pass secrets in store?
//   audience: config.oidcConfig.audience,
// };

// console.log(oidcConfig);

root.render(

    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <QueryClientProvider client={queryClient}>
            <SystemAuthProvider>
              <VendorAuthWrapper>
                <BrowserRouter>
                  <Suspense fallback={<Loading />}>
                    <App />
                  </Suspense>
                </BrowserRouter>
              </VendorAuthWrapper>
            </SystemAuthProvider>
          </QueryClientProvider>
        </PersistGate>
      </Provider>
    </ErrorBoundary>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
